import { Box, Button, Grid, IconProps, Typography } from "@mui/material"
import { CustomPaper } from "../../../../../../components/CustomPaper"
import { useEvidences } from "../../../../../../hooks/evidences/useEvidences"
import { useStyles } from "./styles"
import { DetailActionPlanProps } from "./type"
import EvidenceDetail from "../evidenceDetail"
import { useTranslation } from "react-i18next"
import ActionCard from "../actionCard"
import { icons } from "../../../../../../utils/icons"
import dayjs from "dayjs"
import { Constants } from "../../../../../../utils/constants"
import { VariantCard } from "../actionCard/enum"
import { GoBack } from "../../../../../../components/goBack"
import { LoadingButton } from "@mui/lab"
import { Status } from "../../../../../../utils/enums"
import { useMemo } from "react"
import TypeAndDescription from "../typeAndDescription"
import { useAccordions } from "../../../../../calendar/pages/detail/hooks/useAccordions"
import { useEvidenceDownload } from "../../../../../calendar/pages/detail/hooks"
import { SnackSimple } from "../../../../../../components"

function DetailActionPlan({ asnwerActionPlan, footerButton, userAssigned, closeDetail, aproveDisable }: DetailActionPlanProps) {
    const { t } = useTranslation()
    const { evidences, existEvidences } = useEvidences({ evidencesResponse: asnwerActionPlan?.evidencesAnswer })
    const styles = useStyles()
    const userReview = asnwerActionPlan?.userReview
    const userResponse = asnwerActionPlan?.userResponse
    const status = asnwerActionPlan?.statusId
    const comment = asnwerActionPlan?.comment
    const resonReject = asnwerActionPlan?.reasonRejection
    const styleStatus = useMemo(() => {
        if (status == Status.APPROVED) {
            return {
                status: VariantCard.SUCCESS,
                text: 'actionPlan.aproveBy'
            }
        }
        if (status == Status.REJECTED) {
            return {
                status: VariantCard.ERROR,
                text: 'actionPlan.rejectBy'
            }
        }
        return {
            text: 'actionPlan.emitBy'
        }
    }, [status])

    const { disable, openSnackbar, handleCloseSnackbar, downloadEvidences } = useEvidenceDownload('evidencias de detalle de respuesta',asnwerActionPlan?.evidencesAnswer);

    return (
        <CustomPaper sx={styles.container}>
            <SnackSimple close={handleCloseSnackbar} open={openSnackbar.open} type={openSnackbar.type} message={openSnackbar.message} />
            <Grid  sx={{height:'100%'}} container spacing={3}>
                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <Box className="flex flex-col gap-2 w-full">
                        <GoBack
                            color="primary"
                            arrowProps={{ onClick: () => { closeDetail() }, }}
                            title={t('actionPlan.responseDetail')}
                        />

                        {
                            !!userReview && (
                                <ActionCard
                                    variantCard={styleStatus?.status}
                                    icon={{ position: 'start', icon: <ActionCard.Icon<IconProps> color='primary_company' icon={icons('person')} /> }}
                                >
                                    <ActionCard.Header label={t(styleStatus.text)} />

                                    <ActionCard.Title label={`${userReview?.firstName ?? ''} ${userReview?.lastName ?? ''}`.trim() ?? userAssigned?.fullName} />

                                    <ActionCard.Footer label={dayjs(asnwerActionPlan?.update_time).locale('es').format(Constants.dayjsHumanFormat)} />
                                </ActionCard>
                            )
                        }

                        <ActionCard icon={{ position: 'start', icon: <ActionCard.Icon<IconProps> color='primary_company' icon={icons('person')} /> }} >
                            <ActionCard.Header label={t('actionPlan.emitBy')} />

                            <ActionCard.Title label={`${userResponse?.firstName ?? ''} ${userResponse?.lastName ?? ''}`.trim()} />

                            <ActionCard.Footer label={dayjs(asnwerActionPlan?.create_time).locale('es').format(Constants.dayjsHumanFormat)} />
                        </ActionCard>

                        {
                            !!resonReject && (
                                <TypeAndDescription
                                    description={resonReject}
                                    title={t('actionPlan.rejectMotive')}
                                />
                            )
                        }
                        {
                            !!comment && (
                                <TypeAndDescription
                                    description={comment}
                                    title={t('general.comment')}
                                />
                            )
                        }
                    </Box>
                </Grid>

                <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                    <Box className="flex2 flex-col gap-2 w-full">
                        <Typography variant="subtitle" fontWeight='bold'>{t('actionPlan.evidenceList')}</Typography>
                        <Box sx={styles.mainContainer}>
                                <EvidenceDetail
                                    existEvidences={existEvidences}
                                    evidences={{
                                        image: evidences?.images,
                                        comment: evidences?.comments,
                                        documents: evidences?.documents,
                                        video: evidences?.video,
                                    }}
                                />
                            
                                <Box className="flex w-full item-center gap-2 justify-space mt-30 wrap">
                                    { 
                                        existEvidences && (
                                            <Button  sx={{marginTop:'5px'}} variant='text_primary' onClick={downloadEvidences} disabled={disable}>{t('schedule.buttons.downloadEvidence')}</Button>
                                        )
                                    }
                                    {
                                        ((!!footerButton?.right.show || footerButton?.left.show) && Status.RESPONDED == status && (<>
                                            <Box sx={styles.butonWidth(!existEvidences)} className="flex item-center gap-2 justify-end column">
                                                {footerButton?.left.show && <Button variant="container_transparent" {...footerButton?.left.props ?? {}}>{t('general.reject')}</Button>}

                                                {footerButton?.right && <LoadingButton disabled={aproveDisable} variant="primary_c" {...footerButton?.right.props ?? {}}>{t('general.aprove')}</LoadingButton>}
                                            </Box>
                                            </>))
                                    }
                                </Box>
                        </Box>

                        
                    </Box>
                </Grid>
            </Grid>
        </CustomPaper>
    )
}

export default DetailActionPlan